(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bshirt-timeline"] && !Shopify.designMode) return;
  try {
    
if('IntersectionObserver' in window&&!matchMedia('(prefers-reduced-motion: reduce)').matches){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('bs-waiting');observer.unobserve(entry.target)}}),{threshold:.12});document.querySelectorAll('.bs-history-item').forEach(item=>{if(item.getBoundingClientRect().top>innerHeight)item.classList.add('bs-waiting');observer.observe(item)})}

  } catch(e) { console.error(e); }
})();
})();
